import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Inbox"),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-extrabold text-[#1E2833]" }, "Contact Messages")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "px-3 py-1 bg-[#6CC551] text-white text-xs font-bold rounded-full"
}
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center py-16"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 rounded-full border-4 border-[#6CC551] border-t-transparent animate-spin" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "bg-white rounded-2xl py-16 text-center",
  style: {"border":"1px dashed #e5e7eb"}
}
const _hoisted_9 = {
  class: "w-12 h-12 mx-auto mb-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  style: {"color":"#d1d5db"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-sm",
  style: {"color":"#9ca3af"}
}, "No messages yet.", -1)
const _hoisted_13 = {
  key: 2,
  class: "bg-white rounded-2xl overflow-hidden",
  style: {"border":"1px solid #f3f4f6"}
}
const _hoisted_14 = { class: "w-full text-sm text-left" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", {
  class: "text-xs text-[#1E2833] uppercase bg-[#6CC551]/10",
  style: {"border-bottom":"1px solid #f3f4f6"}
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "From"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Subject"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3" }, "Actions")
  ])
], -1)
const _hoisted_16 = ["onMouseleave"]
const _hoisted_17 = { class: "px-5 py-4" }
const _hoisted_18 = {
  class: "px-5 py-4 font-medium",
  style: {"color":"#374151"}
}
const _hoisted_19 = {
  class: "px-5 py-4 max-w-xs truncate",
  style: {"color":"#6b7280"}
}
const _hoisted_20 = {
  class: "px-5 py-4 whitespace-nowrap",
  style: {"color":"#9ca3af"}
}
const _hoisted_21 = { class: "px-5 py-4" }
const _hoisted_22 = { class: "flex items-center gap-3" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden" }
const _hoisted_26 = {
  class: "flex items-start justify-between px-6 py-5",
  style: {"border-bottom":"1px solid #f3f4f6"}
}
const _hoisted_27 = { class: "min-w-0 pr-4" }
const _hoisted_28 = {
  class: "text-xs mb-0.5",
  style: {"color":"#9ca3af"}
}
const _hoisted_29 = { class: "text-base font-bold text-[#1E2833] leading-snug" }
const _hoisted_30 = { class: "text-sm text-[#6CC551] mt-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "px-6 py-5" }
const _hoisted_34 = {
  class: "text-sm leading-relaxed whitespace-pre-wrap",
  style: {"color":"#374151"}
}
const _hoisted_35 = {
  class: "px-6 py-4 flex items-center justify-between gap-3",
  style: {"background":"#f9fafb","border-top":"1px solid #f3f4f6"}
}
const _hoisted_36 = ["href"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
  })
], -1)

import { computed, onMounted, ref } from 'vue';
import axios from 'axios';
import { url } from '@/functions/endpoint';
import { authService } from '@/services/auth';

interface Message {
  id: number;
  email: string;
  subject: string;
  message: string;
  createdAt: string;
  isRead: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewMessages',
  setup(__props) {

const messages = ref<Message[]>([]);
const loading  = ref(true);
const selected = ref<Message | null>(null);

const unreadCount = computed(() => messages.value.filter((m) => !m.isRead).length);

const headers = () => ({ Authorization: authService.getToken() ?? '' });

const formatDate = (d: string) =>
  new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

const fetchMessages = async () => {
  loading.value = true;
  try {
    const res = await axios.get(`${url}/contact-message`, { headers: headers() });
    messages.value = res.data;
  } finally {
    loading.value = false;
  }
};

const openMessage = async (msg: Message) => {
  selected.value = msg;
  if (!msg.isRead) {
    try {
      await axios.patch(`${url}/contact-message/${msg.id}/read`, {}, { headers: headers() });
      msg.isRead = true;
    } catch {}
  }
};

const deleteMessage = async (id: number) => {
  if (!confirm('Delete this message?')) return;
  try {
    await axios.delete(`${url}/contact-message/${id}`, { headers: headers() });
    messages.value = messages.value.filter((m) => m.id !== id);
  } catch {}
};

onMounted(fetchMessages);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(unreadCount))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(unreadCount)) + " unread ", 1))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (!messages.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11)),
            _hoisted_12
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (msg) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: msg.id,
                    class: "transition-colors",
                    style: _normalizeStyle(!msg.isRead ? 'background: rgba(108,197,81,0.05); border-bottom: 1px solid #f9fafb;' : 'border-bottom: 1px solid #f9fafb;'),
                    onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (($event.currentTarget as HTMLElement).style.background='#f9fafb')),
                    onMouseleave: ($event: any) => (($event.currentTarget as HTMLElement).style.background = !msg.isRead ? 'rgba(108,197,81,0.05)' : '')
                  }, [
                    _createElementVNode("td", _hoisted_17, [
                      _createElementVNode("span", {
                        class: "inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wide",
                        style: _normalizeStyle(msg.isRead
                  ? 'background: #f3f4f6; color: #6b7280;'
                  : 'background: rgba(108,197,81,0.15); color: #6CC551;')
                      }, _toDisplayString(msg.isRead ? 'Read' : 'New'), 5)
                    ]),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(msg.email), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(msg.subject), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(formatDate(msg.createdAt)), 1),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (openMessage(msg)),
                          class: "text-xs font-semibold text-[#6CC551] hover:underline"
                        }, "View", 8, _hoisted_23),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (deleteMessage(msg.id)),
                          class: "text-xs font-semibold text-red-500 hover:underline"
                        }, "Delete", 8, _hoisted_24)
                      ])
                    ])
                  ], 44, _hoisted_16))
                }), 128))
              ])
            ])
          ])),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-150",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (selected.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40",
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (selected.value = null), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", _hoisted_28, _toDisplayString(formatDate(selected.value.createdAt)), 1),
                    _createElementVNode("h2", _hoisted_29, _toDisplayString(selected.value.subject), 1),
                    _createElementVNode("p", _hoisted_30, _toDisplayString(selected.value.email), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (selected.value = null)),
                    class: "flex-shrink-0 transition-colors",
                    style: {"color":"#9ca3af"},
                    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (($event.currentTarget as HTMLElement).style.color='#4b5563')),
                    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (($event.currentTarget as HTMLElement).style.color='#9ca3af'))
                  }, _hoisted_32, 32)
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("p", _hoisted_34, _toDisplayString(selected.value.message), 1)
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("a", {
                    href: `mailto:${selected.value.email}?subject=Re: ${encodeURIComponent(selected.value.subject)}`,
                    class: "flex items-center gap-1.5 px-4 py-2 bg-[#6CC551] text-white text-sm font-semibold rounded-xl hover:bg-green-600 transition-colors"
                  }, [
                    _hoisted_37,
                    _createTextVNode(" Reply via Email ")
                  ], 8, _hoisted_36),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => {deleteMessage(selected.value.id); selected.value = null}),
                    class: "px-4 py-2 text-sm font-semibold text-red-500 hover:bg-red-50 rounded-xl transition-colors"
                  }, "Delete")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})